import type { WhatsNewEntry } from "../types";

/** Release note: Alpha onboarding + feedback (2026-06-25). */
const BODY = `小环的 Alpha 内测正式开始了。作为你的私人工作助理，它现在不只是会答——还会带你快速上手，并且把你的每一次反馈都用起来：你越用，它越懂你。

## 一、不知道问什么？跟着走就行

### 首页有两个入口

打开小环，首页给你两个入口：

- **了解小环**——一分钟看懂它能帮你做什么；
- **使用手册 · Playbook**——挑个模板，填一句就能问。

下面还会根据你们公司的资料，给出几条贴合的开场建议，第一次来也不用从零想问题。

### 挑个模板，填一句就能问

点开「使用手册」，问题按场景分好了类——新手上路、搞懂概念、帮我选择、解决问题。挑中一个模板，把句子里**高亮的地方**换成你的真实情况（不想填就留空，用默认也行），点「开始对话」就直接问出去了，不用自己憋措辞。

### 答案有出处，可点开核对

小环回答前会先查一遍公司资料，**关键内容都带可点击的出处**。看到哪句拿不准，点开来源自己核对，心里有底。

## 二、答得好不好，告诉小环一声

你的反馈很重要——它决定了小环下次答得对不对。有两件事，随手就能做：

### 觉得有用点赞，没解决点踩

每条回答下面都有一排按钮：复制、**点赞**、**点踩**、重新回答、转人工。点了「没帮助」，小环会顺着这条问答**列出几个可能的原因**，你点一下就记下了，不用再填表；想多说两句，也可以在「具体说说看」里补一句。

### 对小环本身有想法：意见反馈

如果是对产品的建议——发现了 bug、想要个新功能、或者哪儿用着别扭——点左下角的「**意见反馈**」：填个标题、选个分类、说说情况，需要的话再贴张截图，提交就好。

## 三、想让它更准？到标注台搭把手

你点过踩、转过人工的那些问答，会自动汇集到「**标注台**」。在这里，你可以挑出该改的回答，写上更准确的标准答案、勾上原因，沉淀下来。下次再有人问到类似问题，小环就答得更准了。

## 一句话总结：你能做的三件事

1. **不知道问什么** → 打开「使用手册」，挑个模板填一句；
2. **答得好或不好** → 顺手点个赞或踩，告诉小环哪里对、哪里不对；
3. **对产品有想法** → 用「意见反馈」直接说。

就这么简单。Alpha 内测期间，多用、多反馈——小环会越来越懂你。`;

export const onboardingFeedback: WhatsNewEntry = {
  id: "2026-06-25-onboarding-feedback",
  date: "2026-06-25",
  title: "带你上手，听你反馈",
  summary:
    "Alpha 内测开启：首页双入口 + 使用手册带你快速上手；答案点赞点踩、意见反馈让小环越用越懂你。",
  video: "/whatsnew/onboarding-feedback.mp4",
  body: BODY
};
